import { Theme, makeStyles, createStyles } from '@material-ui/core';
import { colors } from 'design-system';

const DESKTOP_HEIGHT = 78;
const MOBILE_HEIGHT = 92;

type Props = {
  appbarHeight: string | number;
};

const makeDashboardToolbarStyles = makeStyles<Theme, Props>((theme: Theme) =>
  createStyles({
    appBarContent: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: 0,
      paddingRight: 0,
    },
    appBarSpacer: {
      width: '100%',
    },
    appBar: {
      backgroundColor: colors.madison,
      height: DESKTOP_HEIGHT,
      [theme.breakpoints.down('sm')]: {
        height: ({ appbarHeight }) => appbarHeight ?? MOBILE_HEIGHT,
      },
      [theme.breakpoints.up('md')]: {
        padding: 0,
      },
    },
    appBarOffset: {
      width: '100%',
      height: DESKTOP_HEIGHT,
      [theme.breakpoints.down('sm')]: {
        height: ({ appbarHeight }) => appbarHeight ?? MOBILE_HEIGHT,
      },
    },
    appBarText: {
      color: colors.white,
    },
    toolbarItem: {
      margin: theme.spacing(2),
    },
    profileItem: {
      marginTop: 0,
      marginBotttom: 0,
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
    },
    searchContainer: {
      width: 380,
      height: 45,
      backgroundColor: colors.white,
      borderRadius: 23,
      display: 'inline-block',
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        width: 330,
      },
    },
    searchInput: {
      width: `calc(90% - ${theme.spacing(2)}px)`,
      marginTop: 12,
      marginLeft: theme.spacing(1),
      fontFamily: 'Noto Sans SC',
      height: 21,
      border: 'none',
      '&:focus': {
        outline: 'none',
      },
    },
    searchInputIcon: {
      position: 'absolute',
      right: theme.spacing(2),
      top: 10,
    },
    fab: {
      position: 'absolute',
      bottom: 12,
      right: 90,
      backgroundColor: colors.bright_turquoise,
      color: colors.white,
      '&:hover': {
        backgroundColor: colors.madison,
      },
    },
    divider: {
      position: 'absolute',
      bottom: 16,
      right: 1,
      width: 1,
      height: 36,
      backgroundColor: colors.white,
    },
  }),
);

export default makeDashboardToolbarStyles;
